import http from '../utils/http';
import axios from 'axios';
import i18n from '@/main';
import StatusLaudo from '@/constants/StatusLaudo';

const baseRoute = '/laudo';

export default {
    getInformacoesByIdLaudo(idLaudo) {
        return http.get({
            url: baseRoute + `/informacoes/${idLaudo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoesDoLaudo')
        });
    },

    cadastrarLaudos(body = {}) {
        return http.post({
            url: baseRoute + '/cadastrar',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cadastrandoLaudo')
        });
    },

    cancelarLaudo(laudo) {
        return http.put({
            url: baseRoute + '/cancelar',
            data: { ...laudo },
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cancelandoLaudo')
        });
    },

    atualizarStatusLaudo(laudo) {
        return http.put({
            lockScreen: true,
            url: baseRoute + '/updateStatus',
            data: { ...laudo }
        });
    },

    requestLaudos(body, { page, size, sort }) {
        return http.post({
            url:
                baseRoute +
                `/filtrar?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoLaudos')
        });
    },

    getSituacoesPossiveis() {
        return http.get({
            url: baseRoute + '/situacao',
            lockScreen: false
        });
    },

    getStatusPossiveis() {
        return http.get({
            url: baseRoute + '/status',
            lockScreen: false
        });
    },

    sendResultados(body) {
        return http.post({
            url: baseRoute + '/finalizar',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.salvandoResultadoDoLaudo')
        });
    },

    getCulturas() {
        return http.get({
            url: baseRoute + '/culturas',
            lockScreen: false
        });
    },

    getTipoLaudo() {
        return http.get({
            url: baseRoute + '/tipo-laudo',
            lockScreen: false
        });
    },

    downloadLaudo(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/download/${id}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoLaudoParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    solicitarConfirmacaoLaudo(id) {
        return http.put({
            url: baseRoute + `/solicitar-confirmacao/${id}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.enviandoLaudoParaConfirmacao')
        });
    },

    getElegibilidadeRenovabio(codigoCar) {
        return http.get({
            url: baseRoute + `/car-elegivel-renovabio?car=${codigoCar}`,
            lockScreen: false
        });
    },

    downloadArquivoLaudo(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/download-arq-laudo/${id}`,
                    responseType: 'blob'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    getRepresentantes(query = '') {
        return http.get({
            url: baseRoute + `/representantes?query=${query}`,
            lockScreen: false
        });
    },

    getCredores(query = '') {
        return http.get({
            url: baseRoute + `/credores?query=${query}`,
            lockScreen: false
        });
    },

    getTerritorios(query = '') {
        return http.get({
            url: baseRoute + `/territorios?query=${query}`,
            lockScreen: false
        });
    },

    getCar(query = '') {
        return http.get({
            url: baseRoute + `/car?query=${query}`,
            lockScreen: false
        });
    },

    exportXlsx(idTipoLaudo) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `${baseRoute}/xlsx/${idTipoLaudo}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    baixarShape(id) {
        return http.get({
            url: baseRoute + `/${id}/shape`,
            responseType: 'blob',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.preparandoShapeParaDownload')
        });
    },
    removerArquivoTemp(nomeArquivo) {
        return http.delete({
            url: baseRoute + '/remover-arq-temp',
            data: { nomeArquivo }
        });
    },

    vincularAnalista(idLaudo) {
        return http.get({
            url: baseRoute + `/${idLaudo}/vincular-analista`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.vinculandoAnalistaAoLaudo')
        });
    },

    uploadResultadoConformidade(laudoId, tipoInsumo, arquivo) {
        let formData = new FormData();
        formData.append('file', arquivo);

        formData.append('laudoId', laudoId);
        formData.append('tipoInsumo', tipoInsumo);

        let url =
            process.env.VUE_APP_HTTP_PATH + baseRoute + '/upload-conformidade';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    uploadResultadoLaudo(arquivoComResultado, laudoId, status) {
        return this.uploadResultadoLaudoCompleto(arquivoComResultado, laudoId, status, false);
    },

    uploadResultadoLaudoRenovabio(arquivoComResultado, laudoId, elegibilidadeRenovabio) {
        return this.uploadResultadoLaudoCompleto(arquivoComResultado, laudoId, StatusLaudo['NAO_APLICADO'], elegibilidadeRenovabio);
    },

    uploadResultadoLaudoCompleto(arquivoComResultado, laudoId, status, elegibilidadeRenovabio) {
        const formData = new FormData();

        const url = process.env.VUE_APP_HTTP_PATH + '/laudo/finalizar';

        formData.append('file', arquivoComResultado.raw);

        formData.append('laudoId', laudoId);
        formData.append('statusId', status);
        formData.append('elegibilidadeRenovabio', elegibilidadeRenovabio);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    atualizarGeometria(body) {
        return http.post({
            url: baseRoute + '/atualizar-geometria',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.atualizandoLaudo')
        });
    },

    buscarTotalizadoresSituacao(idTipoLaudo) {
        if (idTipoLaudo) {
            return http.get({
                url: baseRoute + `/totalizadores-situacao/${idTipoLaudo}`,
                lockScreen: false
            });
        }
        return http.get({
            url: baseRoute + `/totalizadores-situacao`,
            lockScreen: false
        });
    },

    buscarTotalizadoresSituacaoMensal(idTipoLaudo) {
        if (idTipoLaudo) {
            return http.get({
                url: baseRoute + `/totalizadores-situacao/mensal/${idTipoLaudo}`,
                lockScreen: false
            });
        }
        return http.get({
            url: baseRoute + `/totalizadores-situacao/mensal`,
            lockScreen: false
        });
    },

    async uploadPlanilha(planilha) {
        const url = process.env.VUE_APP_HTTP_PATH + baseRoute + '/upload-planilha';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        try {
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            return Promise.reject(error);
        }
    },

    async downloadPlanilhaErro(arquivoHash) {
        const fileLink = document.createElement('a');
        try {
            return http.get({
                url: baseRoute + `/${arquivoHash}/download-planilha-erro`,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
            }).then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    processarPlaninlha(arquivoHash) {
        return http.post({
            url: baseRoute + `/${arquivoHash}/processar-planilha`,
            data: null,
            lockScreen: false
        });
    },

    quantidadeLaudosRenovabioProcessados(body) {
        return http.post({
            url: baseRoute + '/qtde-laudos-processados',
            data: body,
            lockScreen: false
        });
    },

    async processarDownloadTodosLaudosProcessadosRenovabios(body) {
        return http.post({
            url: baseRoute + '/download-todos-laudos',
            responseType: 'blob',
            data: body,
            lockScreen: false
        });
    },

    async processarDownloadParcialLaudosProcessadosRenovabios(body = {}, count = 0) {
        const fileLink = document.createElement('a');

        let lockMessage = '';
        if (count === 1) {
            lockMessage = i18n.t('mensagens.laudos.renovabio.lockMessageDownloadParcial1');
        } else if (count > 1) {
            lockMessage = i18n.t('mensagens.laudos.renovabio.lockMessageDownloadParcial2', { count });
        }

        return http.post({
            url: baseRoute + '/download-lote',
            responseType: 'blob',
            data: body,
            lockScreen: true,
            lockMessage
        }).then(response => {
            if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                fileLink.href = fileURL;
                const filenameRegex =
                    /filename=['"]?([^;\r\n"']*)['"]?;?/;
                const contentDisposition =
                    response.headers['content-disposition'];

                fileLink.setAttribute(
                    'download',
                    filenameRegex.exec(contentDisposition)[1]
                );
                document.body.appendChild(fileLink);

                fileLink.click();
                return Promise.resolve();
            }
        });
    },

    verificarTipoArquivo(planilha) {
        const url = process.env.VUE_APP_HTTP_PATH + baseRoute + '/verificar-tipo-arquivo';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        try {
            return axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            return Promise.reject(error);
        }
    },

    verificarLaudosNovos(cars, idTipoLaudo) {
        const data = {
            cars,
            idTipoLaudo
        };

        return http.post({
            url: baseRoute + '/verificar-novos',
            data,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.laudos.renovabio.verificandoLaudosJaCadastrados')
        });
    },

    validarTamanhoTerritorio(informacaoLaudoDTO) {
        return http.post({
            url: baseRoute + '/verificar-tamanho-territorio',
            data: informacaoLaudoDTO,
            lockScreen: false
        });
    },

    cadastrarLaudoComArquivo(laudoDTO, arquivo) {
        const formData = new FormData();

        formData.append('laudoDTO', JSON.stringify(laudoDTO));
        formData.append('arquivo', arquivo);
    
        const url = process.env.VUE_APP_HTTP_PATH + baseRoute + '/cadastrar-com-arquivo';
    
        return axios.post(url, formData, {
            lockScreen: true,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    downloadArquivoLaudoAnalise(idLaudo) {
        const url = `${process.env.VUE_APP_HTTP_PATH}${baseRoute}/download-arquivo/${idLaudo}`;
        return axios.get(url, {
            lockScreen: true,
            responseType: 'blob',
            headers: {
                'Accept': 'application/zip'
            }
        });
    },

    listarAnoRenovabio() {
        return http.get({
            url: baseRoute + `/renovabio/anos`,
            lockScreen: false
        });
    }
};
